import { useState, useEffect } from "react";

// Components
import Navbar from "./components/Navbar";
import Chat from "./components/Chat";
import GenKey from "./components/GenKey";

const App = () => {
  return (
    <div className="h-100">
      <Navbar />
      <Chat />
    </div>
  );
};

export default App;
